import { parseLocaleNumber } from './formatNumbers'

/**
 * Utility function to parse specific fields to float in an object
 * @param obj - The object to parse
 * @param fields - Array of field names to parse to float
 * @returns The object with parsed float fields
 */
export const parseFloatFields = <T extends Record<string, any>>(
  obj: T,
  fields: (keyof T)[]
): T => {
  const parsed = { ...obj }

  fields.forEach((field) => {
    if (
      parsed[field] !== undefined &&
      parsed[field] !== null &&
      parsed[field] !== ''
    ) {
      const value = parsed[field]
      // If it's already a number, keep it; if it's a string, parse it
      if (typeof value === 'string') {
        const floatValue = /^\s*-?\d+(\.\d+)?\s*$/.test(value)
          ? Number(value)
          : parseLocaleNumber(value)
        if (floatValue !== null) {
          parsed[field] = floatValue as any
        }
      } else if (typeof value === 'number') {
        // Keep as is
        parsed[field] = value
      }
    }
  })

  return parsed
}

/**
 * Parse cost/budget related fields in Actions
 */
export const parseActionFloatFields = <T extends Record<string, any>>(
  action: T
): T => {
  return parseFloatFields(action, ['Cout', 'CoutTotal'] as (keyof T)[])
}

/**
 * Parse budget field in Projet
 */
export const parseProjetFloatFields = <T extends Record<string, any>>(
  projet: T
): T => {
  return parseFloatFields(projet, ['Budget'] as (keyof T)[])
}

/**
 * Parse budget field in Mission
 */
export const parseMissionFloatFields = <T extends Record<string, any>>(
  mission: T
): T => {
  return parseFloatFields(mission, ['Budget'] as (keyof T)[])
}

/**
 * Parse Montant field in CoutSupplementaire
 */
export const parseCoutSupplementaireFloatFields = <
  T extends Record<string, any>,
>(
  coutSupplementaire: T
): T => {
  return parseFloatFields(coutSupplementaire, ['Montant'] as (keyof T)[])
}

